import React from "react";
import Diccionario from "../../instituto/diccionario/Diccionario";

const Glosario = () => {
  return <Diccionario type={"ASG"} idTranslate={105}/>;
};

export default Glosario;
